import React from 'react';
import './ReporteFiltrosEncabezadoLista.css';

/**
 * Muestra filtros en encabezado: línea simple o chips cuando hay varios ítems.
 * `--report`: bloque centrado (encabezado del reporte impreso).
 * `--page`: alineado a la izquierda (barra superior de Reportes).
 */
export default function ReporteFiltrosEncabezadoLista({
  label,
  texto = '',
  items = [],
  className = '',
  uppercase = false,
}) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  const summary = String(texto ?? '').trim();
  if (!summary && list.length === 0) return null;

  const format = (value) => {
    const s = String(value).trim();
    return uppercase ? s.toUpperCase() : s;
  };

  const isReport = className.includes('--report');
  const displayItems = list.length > 0 ? list : summary ? [summary] : [];
  const singleLine = displayItems.length <= 1;

  return (
    <div
      className={[
        'reporte-filtros-meta',
        isReport ? 'reporte-filtros-meta--centered' : 'reporte-filtros-meta--inline',
        singleLine ? 'reporte-filtros-meta--single' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="reporte-filtros-meta__label">{label}:</span>
      {singleLine ? (
        <span className="reporte-filtros-meta__text">{format(displayItems[0] || summary)}</span>
      ) : (
        <span className="reporte-filtros-meta__chips" role="list">
          {displayItems.map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="reporte-filtros-meta__chip"
              role="listitem"
            >
              {format(item)}
            </span>
          ))}
        </span>
      )}
    </div>
  );
}
